// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Ellipse67Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 980 657"}
      height={"1em"}
      width={"1em"}
      style={{
        stroke: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M978.316 328.04c0 90.259-54.595 172.063-143.048 231.337-88.449 59.27-210.682 95.954-345.735 95.954-135.053 0-257.286-36.684-345.735-95.954C55.345 500.103.75 418.299.75 328.04c0-90.259 54.595-172.063 143.048-231.336C232.247 37.434 354.48.75 489.533.75c135.053 0 257.286 36.684 345.735 95.954 88.453 59.273 143.048 141.077 143.048 231.336z"
        }
        stroke={"currentColor"}
        strokeWidth={"1.5"}
      ></path>
    </svg>
  )
}

export default Ellipse67Icon
/* prettier-ignore-end */
